<div class="dialogTitle">
  <h2 *ngIf="!data.readOnly">
    {{
      (data.single
        ? "organisations.select.title.single"
        : "organisations.select.title.multi"
      ) | translate
    }}
  </h2>
  <h2 *ngIf="data.readOnly">
    {{ "organisations.title" | translate }}
  </h2>
</div>
<mat-dialog-content>
  <ca-organisation-list-select
    [organisations]="data.organisations"
    [selectedIds]="selectedIds"
    [disabledIds]="data.disabledIds ?? []"
    [single]="data.single"
    [readOnly]="data.readOnly"
    (selectedIdChange)="onSelectedIdChange($event)"
  >
  </ca-organisation-list-select>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="dialogOptions">
    <button
      color="primary"
      [disabled]="!data.readOnly && !selectedIds.length"
      mat-flat-button
      [mat-dialog-close]="selectedIds"
    >
      {{ "organisations.select.done" | translate }}
    </button>

    <!-- Select all/none only available with multi-select -->
    <ng-container
      *ngIf="!data.readOnly && !data.single && data.organisations as orgs"
    >
      <button
        *ngIf="selectedIds.length < (orgs | keyvalue).length"
        mat-button
        (click)="selectOrgs(orgs)"
      >
        {{ "organisations.select.all" | translate }}
      </button>
      <button
        *ngIf="selectedIds.length === (orgs | keyvalue).length"
        mat-button
        (click)="selectOrgs({})"
      >
        {{ "organisations.select.none" | translate }}
      </button>
    </ng-container>
  </div>
</mat-dialog-actions>
